var _circle, _ellipse, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVegNonveg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 61,
    fill: "#F5F7F9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.449,
    cy: 69.0462,
    rx: 18.7156,
    ry: 12.4771,
    fill: "#2E8115"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.257 89.2296C76.1653 82.1837 74.6851 76.9972 73.7065 75.2847C74.4405 75.1012 76.0552 74.8443 76.6423 75.2847C76.8258 75.8351 78.2937 78.5874 79.2111 78.5874C79.9451 78.5874 80.8625 76.3856 81.2295 75.2847C82.3304 75.407 84.7157 75.6516 85.4497 75.6516C85.1561 78.5874 86.1836 79.8106 86.7341 80.0553L89.6698 77.303C89.7922 77.4253 90.4038 78.0002 91.8717 79.3214C88.0552 83.8718 86.8564 89.5354 86.7341 91.7984C83.8594 91.248 77.3396 89.9636 74.257 89.2296Z",
    fill: "#BFFC73"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6692,
    cy: 63.5415,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.9358,
    cy: 67.9448,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.9358,
    cy: 72.3486,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.7698,
    cy: 75.2844,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.8083,
    cy: 76.7524,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5774,
    cy: 76.0181,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.0823,
    cy: 76.0181,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.4861,
    cy: 76.3852,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.4211,
    cy: 78.9543,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5608,
    cy: 78.5872,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.128,
    cy: 74.1833,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.698,
    cy: 69.78,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.063,
    cy: 64.6426,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.0271,
    cy: 60.6052,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.258,
    cy: 58.404,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.1184,
    cy: 58.0369,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.9817,
    cy: 57.303,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.3108,
    cy: 56.9358,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.9094,
    cy: 56.9358,
    r: 2.93578,
    fill: "#2E8115"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.6067,
    cy: 60.2388,
    r: 2.93578,
    fill: "#2E8115"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4149 54.6688L31.9233 49.1604L36.6053 53.2917L30.5461 59.3509C32.2341 60.1949 32.6806 62.0736 32.2661 63.6552C31.7682 65.5548 29.5075 66.4055 27.6021 65.9299C24.8803 65.2505 24.6795 62.5793 25.0377 61.0034C24.8541 61.0952 24.2667 61.3339 23.3853 61.5542C20.3557 61.8297 17.3261 57.9738 20.0803 54.6688C22.2837 52.0248 25.2215 53.5671 26.4149 54.6688Z",
    fill: "#F3CF91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.424 53.2921L31.5682 49.4362C30.1911 45.0296 32.497 42.275 32.7724 42.275C32.9504 42.275 33.5455 41.3552 34.2416 40.0355C35.0775 38.4507 35.4079 36.6616 35.623 34.8828C36.9344 24.0375 44.0389 20.2816 49.7458 19.1401C55.2542 18.0382 66.2709 23.5468 65.9955 31.8093C65.9955 46.4065 57.7954 48.8969 55.2542 49.1608C52.6017 49.4362 47.5425 46.9574 44.5128 51.3641C42.0892 54.8895 37.4438 54.1183 35.424 53.2921Z",
    fill: "#FCA531"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 27.9998C43.1667 24.4998 49.6 18.3 60 25.5",
    stroke: "#773738",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegNonveg);
export default __webpack_public_path__ + "static/media/veg-nonveg.3d711c53d5418ece48c001d2df36d85c.svg";
export { ForwardRef as ReactComponent };